import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class Eyeball extends Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stroke: PropTypes.string,
    fill: PropTypes.string,
    svgProps: PropTypes.object
  };

  static defaultProps = {
    className: "",
    size: "inherit",
    stroke: "currentColor",
    fill: "currentColor",
    svgProps: {}
  };

  get defaultHeight() {
    return 24;
  }

  get defaultWidth() {
    return 24;
  }

  get size() {
    return this.props.size;
  }

  get width() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultWidth;
    return this.size;
  }

  get height() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultHeight;
    return this.size;
  }

  get viewBox() {
    return "0 0 24 24";
  }

  get classes() {
    const { className } = this.props;
    return classnames("manicon-svg", className);
  }

  get fill() {
    return this.props.fill;
  }

  get stroke() {
    return this.props.stroke;
  }

  render() {
    const baseSvgProps = {
      xmlns: "http://www.w3.org/2000/svg",
      className: this.classes,
      width: this.width,
      height: this.height,
      viewBox: this.viewBox,
      fill: this.fill
    };

    const svgProps = Object.assign(baseSvgProps, this.props.svgProps);

    return (
      <svg {...svgProps}>
        <path d="M20.2457405,11.4790231 C19.6783989,10.853779 19.0310749,10.2281368 18.3165344,9.64510007 C16.2971738,7.99738186 14.1564315,7.01539998 12,7.01539998 C9.84356852,7.01539998 7.70282618,7.99738186 5.68346559,9.64510007 C4.96892513,10.2281368 4.32160109,10.853779 3.75425948,11.4790231 C3.572291,11.6795632 3.42024661,11.8554474 3.30000079,12 C3.42024661,12.1445526 3.572291,12.3204368 3.75425948,12.5209769 C4.32160109,13.146221 4.96892513,13.7718632 5.68346559,14.3548999 C7.70282618,16.0026181 9.84356852,16.9846 12,16.9846 C14.1564315,16.9846 16.2971738,16.0026181 18.3165344,14.3548999 C19.0310749,13.7718632 19.6783989,13.146221 20.2457405,12.5209769 C20.427709,12.3204368 20.5797534,12.1445526 20.6999992,12 C20.5797534,11.8554474 20.427709,11.6795632 20.2457405,11.4790231 Z M21.7394239,12.2995677 C21.7032367,12.347926 21.636235,12.4338115 21.5398229,12.5518927 C21.3814041,12.7459167 21.196439,12.961382 20.9863064,13.1929606 C20.3872379,13.8531697 19.7045611,14.5129805 18.9487406,15.1297001 C16.76707,16.9098569 14.424106,17.9846 12,17.9846 C9.57589396,17.9846 7.23293003,16.9098569 5.05125936,15.1297001 C4.29543887,14.5129805 3.61276212,13.8531697 3.01369357,13.1929606 C2.80356097,12.961382 2.61859589,12.7459167 2.46017715,12.5518927 C2.36376504,12.4338115 2.29676327,12.347926 2.26057611,12.2995677 L2.03640556,12 L2.26057611,11.7004323 C2.29676327,11.652074 2.36376504,11.5661885 2.46017715,11.4481073 C2.61859589,11.2540833 2.80356097,11.038618 3.01369357,10.8070394 C3.61276212,10.1468303 4.29543887,9.48701947 5.05125936,8.87029991 C7.23293003,7.0901431 9.57589396,6.01539997 12,6.01539997 C14.424106,6.01539997 16.76707,7.0901431 18.9487406,8.87029991 C19.7045611,9.48701947 20.3872379,10.1468303 20.9863064,10.8070394 C21.196439,11.038618 21.3814041,11.2540833 21.5398229,11.4481073 C21.636235,11.5661885 21.7032367,11.652074 21.7394239,11.7004323 L21.9635944,12 L21.7394239,12.2995677 Z M12,15 C10.3431457,15 8.99999999,13.6568543 8.99999999,12 C8.99999999,10.3431457 10.3431457,8.99999999 12,8.99999999 C13.6568543,8.99999999 15,10.3431457 15,12 C15,13.6568543 13.6568543,15 12,15 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,9.99999999 12,9.99999999 C10.8954305,9.99999999 9.99999999,10.8954305 9.99999999,12 C9.99999999,13.1045695 10.8954305,14 12,14 Z" />
      </svg>
    );
  }
}
